import { ProductId } from 'src/replicant/iap/iap.ruleset';
import { duration } from 'src/replicant/utils/duration';
import { ShopBundlePack } from '../match2/shopbundles/match2-shopbundles.ruleset';

/**
 * Packs of rewards per product id, excluding free and paid gems, which are set in iap.ruleset already
 */
export const petStarterPacks: Record<string, ShopBundlePack> = {
  buruburu_pet_starter_pack: {
    tag: 'hidden', // Do now show in shop
    rewards: [
      { type: 'energy', duration: duration({ hours: 2 }) },
      { type: 'wrapper', id: 'all_powerups', amount: 4 },
      { type: 'wrapper', id: 'all_boosters', amount: 4 },
    ],
  },
  buruburu_pet_starter_pack_2: {
    tag: 'starterPackPromo',
    fixedPrice: 10,
    rewards: [
      { type: 'wrapper', id: 'all_powerups', amount: 1 },
      { type: 'wrapper', id: 'all_boosters', amount: 1 },
    ],
  },
  buruburu_pet_starter_pack_3: {
    tag: 'starterPackPromo',
    fixedPrice: 10,
    rewards: [
      { type: 'energy', duration: duration({ minutes: 30 }) },
      { type: 'bPoints', amount: 10000 },
    ],
  },
};

/**
 * List of pet starter pack products
 */
export const petStarterPackProducts = [
  'buruburu_pet_starter_pack',
  'buruburu_pet_starter_pack_2',
  'buruburu_pet_starter_pack_3',
] satisfies ProductId[];

/**
 * Pet starter pack product id
 */
export type PetStarterPackProductId = (typeof petStarterPackProducts)[number];

/**
 * Starter pack product id
 */
export type StarterPackProductId =
  | PetStarterPackProductId
  | 'buruburu_starter_pack';
